import {
  getToaster,
  type ToastId
} from '~/components/Global/Interactions/Toast/getToaster'
import type { ToastType } from '~/components/Global/Interactions/Toast/ToastType'

export type { ToastId } from '~/components/Global/Interactions/Toast/getToaster'

export const toast = (
  title?: string,
  content?: string,
  type?: ToastType,
  durationMs?: number
): ToastId | false => getToaster().current(title, content, type, durationMs)

export const dismissToast = (id: ToastId): void => {
  getToaster().dismiss(id)
}
